import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import '../../actionmenu.scss'
import { renderFullDate } from '../../../../../utils/time'

// Elements
import Grid from '../../../../elements/grid'

class ResendText extends PureComponent {

  constructor (props) {
    super(props)
    this.state = {
    }
  }

  componentDidMount () {
    this.setState({
    })
  }

  componentWillReceiveProps (nextProps) {
    // console.log('[OrderActions] props', nextProps)
  }

  render () {
    const renderText = () => {
      if (this.props.isLoadingLastHistory) {
        return (
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        )
      }
      if (!this.props.lastHistory || this.props.lastHistory.FoundHistory !== true) {
        return null
      }
      let name = this.props.lastHistory.UserName
      let date = renderFullDate(this.props.lastHistory.Date)

      return (
        <div>
          <Grid justify='start' spacing={1}>
            <span>{this.props.t('14937')}</span>
            <span>{name}</span>
          </Grid>
          <Grid justify='start' spacing={1}>
            <span>{this.props.t('14938')}</span>
            <span>{date}</span>
          </Grid>
          {this.props.lastHistory.EconomicInvoiceId > 0 && (
            <Grid justify='start' spacing={1}>
              <span>{this.props.t('14924')}</span>
              <span>{this.props.lastHistory.EconomicInvoiceId}</span>
            </Grid>)}
          {this.props.lastHistory.EconomicAddonInvoiceId > 0 && (
            <Grid justify='start' spacing={1}>
              <span>{this.props.t('14925')}</span>
              <span>{this.props.lastHistory.EconomicAddonInvoiceId}</span>
            </Grid>)}
          {this.props.lastHistory.EconomicKickbackInvoiceId > 0 && (
            <Grid justify='start' spacing={1}>
              <span>{this.props.t('14926')}</span>
              <span>{this.props.lastHistory.EconomicKickbackInvoiceId}</span>
            </Grid>)}
          {this.props.assessment && (
            <div>{this.props.t('14927')} {this.props.t('14949')}</div>
          )}
          {!this.props.assessment && (
            <div>{this.props.t('14927')} {this.props.t('14939')}</div>
          )}
        </div>
      )
    }
    let resendText = (!this.props.lastHistory || !this.props.lastHistory.FoundHistory) ? this.props.t('13507') : this.props.assessment ? '' + this.props.t('14950') + '.' : '' + this.props.t('13706') + '.'
    if (this.props.isLoadingLastHistory) {
      resendText = ''
    }
    return (
      <div className='pg-mb-2'>
        <div className='pg-my-2'>{resendText}</div>
        {renderText()}
        {this.props.children}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
})(ResendText)



// WEBPACK FOOTER //
// ./src/app/shared/components/ActionMenu/OrderActions/ResendText/index.js